import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export function ConvertBox({ p, onDone }) {
  const [f, setF] = useState({ plan: "essencial", months: "12", email: p.email || "", owner_name: "" });
  const [busy, setBusy] = useState(false);
  const convert = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/prospect/prospects/${p.id}/convert`, { ...f, months: Number(f.months) });
      toast.success(data.invite_sent ? "Cliente criado e convite enviado" : "Cliente criado (convite não enviado)");
      onDone();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const paid = async () => {
    try { await api.post(`/prospect/prospects/${p.id}/payment-received`); toast.success("Plano ativado"); onDone(); } catch (e) { toast.error(apiError(e)); }
  };
  if (p.org_id) {
    return (
      <div className="space-y-2 text-sm" data-testid="converted-box">
        <p>Cliente GestaCV desde {new Date(p.converted_at).toLocaleDateString("pt-PT")} · plano {p.plan} {p.months} meses · 30 dias de teste.</p>
        {p.paid_at ? <p className="font-semibold text-primary" data-testid="paid-label">Pagamento recebido em {new Date(p.paid_at).toLocaleDateString("pt-PT")}</p>
          : <Button size="sm" onClick={() => window.confirm("Confirmar pagamento recebido e ativar o plano?") && paid()} data-testid="payment-received-btn">Pagamento recebido</Button>}
      </div>
    );
  }
  return (
    <div className="grid gap-2 text-sm sm:grid-cols-2" data-testid="convert-form">
      <div><Label>Plano</Label>
        <Select value={f.plan} onValueChange={(v) => setF({ ...f, plan: v })}><SelectTrigger data-testid="convert-plan"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="essencial">Essencial</SelectItem><SelectItem value="pro">Pro</SelectItem></SelectContent></Select></div>
      <div><Label>Duração</Label>
        <Select value={f.months} onValueChange={(v) => setF({ ...f, months: v })}><SelectTrigger data-testid="convert-months"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="6">6 meses</SelectItem><SelectItem value="12">12 meses</SelectItem></SelectContent></Select></div>
      <div><Label>Nome do responsável</Label><Input value={f.owner_name} onChange={(e) => setF({ ...f, owner_name: e.target.value })} data-testid="convert-owner" /></div>
      <div><Label>Email de acesso</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="convert-email" /></div>
      <p className="text-xs text-muted-foreground sm:col-span-2">Cria a conta com 30 dias de teste, publica a demonstração como site oficial (sem faixa) e envia o convite. {p.country === "Portugal" && "Portugal: só site + reservas, sem faturação."}</p>
      <Button className="rounded-full sm:col-span-2" disabled={busy} onClick={() => window.confirm(`Converter ${p.name} em cliente GestaCV?`) && convert()} data-testid="convert-btn">Converter em cliente GestaCV</Button>
    </div>
  );
}
